<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import { GravyPath } from "@/path";
import Add from "@/views/pages/Dilfoods/Gravy/Orders/add.vue";
import AccpetOrders from "@/views/pages/Dilfoods/Gravy/Orders/accpetOrders";
import MarkAsShipped from "@/views/pages/Dilfoods/Gravy/Orders/markAsShipped";
import Swal from "sweetalert2";
import View_items from "@/views/pages/Dilfoods/Gravy/Orders/view_items";
import moment from "moment";
import Payments from "./payments.vue";
import EditIcon from "@/views/pages/Dilfoods/Common/icons/EditIcon.vue";
import DeleteIcon from "@/views/pages/Dilfoods/Common/icons/DeleteIcon.vue";
import DeliveredIcon from "@/views/pages/Dilfoods/Common/icons/DeliveredIcon.vue";
import ShippedIcon from "@/views/pages/Dilfoods/Common/icons/ShippedIcon.vue";
import DownloadIcon from "@/views/pages/Dilfoods/Common/icons/DownloadIcon.vue";
import PendingIcon from "@/views/pages/Dilfoods/Common/icons/PendingIcon.vue";
import CardIcon from "@/views/pages/Dilfoods/Common/icons/CardIcon.vue";
import ListIcon from "@/views/pages/Dilfoods/Common/icons/ListIcon.vue";
import RegenerateIcon from "@/views/pages/Dilfoods/Common/icons/RegenerateIcon.vue";
import AcceptIcon from "@/views/pages/Dilfoods/Common/icons/AcceptIcon.vue";
import BrandKit from "./brandKit.vue";
import View_returns from "./OrderReturns/add.vue";

/* Dashboard component */
export default {
  components: {
    View_items,
    View_returns,
    MarkAsShipped,
    AccpetOrders,
    Add,
    BrandKit,
    Layout,
    PageHeader,
    Payments,
    EditIcon,
    DeleteIcon,
    DeliveredIcon,
    DownloadIcon,
    PendingIcon,
    CardIcon,
    ListIcon,
    RegenerateIcon,
    ShippedIcon,
    AcceptIcon,
  },
  data() {
    return {
      title: "Gravy Orders",
      items: [
        {
          text: "List",
        },
        {
          text: "gravy orders",
          active: true,
        },
      ],
      orders: [],
      selectedOrder: {},
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      cdn: process.env.VUE_APP_AWS_CDN,
      filter: [],
      currentPage: 1,
      order_type: "pending",
      search: "",
      fields: [
        "ref_id",
        "restaurant",
        "city",
        "view_items",
        "expected_delivery_date",
        "created_by",
        "created_at",
        "order_status",
        "shipped_at",
        "delivered_at",
        "Payment",
        "invoice",
        "actions",
      ],
    };
  },
  watch: {
    currentPage() {
      this.getOrders();
    },
    order_type() {
      this.getOrders();
    },
    search() {
      this.getOrders();
    },
  },
  methods: {
    async getOrders() {
      try {
        let response = await axios.get(this.base_url + GravyPath.ORDERS.GET, {
          params: {
            page: this.currentPage,
            order_type: this.order_type,
            search: this.search,
          },
        });
        if (response.data.status == true) {
          this.orders = response.data.data;
          console.log(this.orders, "orders");
        }
      } catch (e) {
        console.log(e);
      }
    },
    openPayment(v) {
      this.selectedOrder = v;
      this.$bvModal.show("show-payment");
    },
    reload() {
      this.getOrders();
      this.$bvModal.hide("bv-view-returns");
    },
    setEdit(d) {
      this.selectedOrder = d;
      this.$bvModal.show("bv-add-order");
    },
    addOrder() {
      this.selectedOrder = {};
      this.$bvModal.show("bv-add-order");
    },
    addBrandKit() {
      this.$bvModal.show("bv-add-brand-kit");
    },
    acceptOrder(v) {
      this.selectedOrder = v;
      this.$bvModal.show("bv-accept-order");
    },
    markAsShipped(v) {
      this.selectedOrder = v;
      this.$bvModal.show("bv-mark-as-shipped");
    },
    async markAsDelivered(v) {
      try {
        let res = await axios.post(
          this.base_url + GravyPath.ORDERS.MARK_AS_DELIVERED,
          {
            order_id: v.id,
          }
        );
        if (res.data.status) {
          Swal.fire("success", "", "success");
          this.getOrders();
        }
      } catch (e) {
        console.log(e);
      }
    },
    async markAsPending(v) {
      try {
        let res = await axios.post(
          this.base_url + GravyPath.ORDERS.MARK_AS_PENDING,
          {
            id: v.id,
          }
        );
        if (res.data.status) {
          Swal.fire("success", "", "success");
          this.getOrders();
        } else {
          Swal.fire(res.data.message, "", "error");
        }
      } catch (e) {
        console.log(e);
      }
    },
    async generateInvoice(v) {
      try {
        let res = await axios.get(
          this.base_url + GravyPath.ORDERS.GRAVY_ORDER_INVOICE,
          {
            params: {
              id: v.id,
            },
          }
        );
        if (res.data.status) {
          this.downloadInvoiceFile(res.data.data);
        }
      } catch (e) {
        console.log(e);
      }
    },
    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    downloadInvoiceFile(file) {
      const link = document.createElement("a");
      link.href = this.cdn + "/" + file;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    openItems(v) {
      this.selectedOrder = v;
      this.$bvModal.show("bv-view-order");
    },
    getFormatedDate(v) {
      return moment(v).format("YYYY-MM-DD");
    },
    async deleteOrder(d) {
      try {
        let finalReason = "";

        if (
          this.$store.state.authfack.user.roles.filter(
            (f) => f.name == "SuperAdmin"
          ).length == 0
        ) {
          const { value: selectedReason, isDismissed } = await Swal.fire({
            title: "Please Select the Reason for Deletion",
            input: "select",
            inputOptions: {
              "RP Not Accepting Projections": "RP Not Accepting Projections",
              "Outlet Not Operational": "Outlet Not Operational",
              Deboarded: "Deboarded",
              "Have Enough Stock": "Have Enough Stock",
              "RP Giving Requirements": "RP Giving Requirements",
              Other: "Other",
            },
            inputPlaceholder: "Select a reason",
            showCancelButton: true,
            inputValidator: (value) => {
              if (!value) {
                return "You must select a reason!";
              }
            },
          });

          if (isDismissed) return;

          finalReason = selectedReason;

          if (selectedReason === "Other") {
            const { value: customReason, isDismissed: isOtherDismissed } =
              await Swal.fire({
                title: "Enter Your Reason",
                input: "textarea",
                inputPlaceholder: "Type your reason here...",
                showCancelButton: true,
                inputAttributes: {
                  "aria-label": "Reason",
                  style:
                    "height: 100px; border: 2px solid #3498db; border-radius: 4px; padding: 10px",
                },
                inputValidator: (value) => {
                  if (!value.trim()) {
                    return "Reason cannot be empty!";
                  }
                },
              });

            if (isOtherDismissed) return;

            finalReason = customReason;
          }
        }

        let response = await axios.delete(
          this.base_url + GravyPath.ORDERS.DELETE + "/" + d.id,
          {
            params: {
              delete_reason: finalReason,
            },
          }
        );

        if (response.data.status === true) {
          this.$bvToast.toast("Successfully Deleted", {
            title: "Gravy Deleted",
            variant: "success",
            solid: true,
          });
          this.getOrders();
        }
      } catch (error) {
        console.log(error);
      }
    },
    openReturns(v) {
      this.selectedOrder = v;
      this.$bvModal.show("bv-view-returns");
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getOrders();
    });
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body py-1" style="margin-bottom: 50px">
            <b-row>
              <b-col class="col-sm-3" style="align-self: end">
                <b-row>
                  <b-col align-self="end">
                    <b-button @click="addOrder()" class="btn btn-primary"
                      >Add Order</b-button
                    >
                  </b-col>
                  <b-col align-self="end">
                    <b-button @click="addBrandKit()" class="btn btn-primary"
                      >Add Brand Kit</b-button
                    >
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="4" md="4" lg="3" style="margin-left: auto">
                <label>Search</label>
                <b-form-input
                  class="w-100"
                  v-model="search"
                  :debounce="100"
                ></b-form-input>
              </b-col>
            </b-row>
            <div class="row mb-2">
              <div class="col-md-4">
                <b-modal
                  id="bv-add-order"
                  size="xl"
                  :title="
                    (Object.keys(selectedOrder).length > 0 ? 'Edit' : 'Add') +
                    ' Order'
                  "
                  hide-footer
                >
                  <add
                    @update="reload()"
                    :selected-order="selectedOrder"
                    :order_type="order_type"
                  ></add>
                </b-modal>
                <b-modal
                  id="bv-add-brand-kit"
                  size="xl"
                  title="Brand kit"
                  hide-footer
                >
                  <BrandKit @update="reload()"></BrandKit>
                </b-modal>
                <b-modal
                  id="bv-accept-order"
                  size="xl"
                  :title="'Accept Order'"
                  hide-footer
                >
                  <accpet-orders
                    @update="reload()"
                    :selected-order="selectedOrder"
                  ></accpet-orders>
                </b-modal>
                <b-modal
                  id="bv-view-order"
                  size="xl"
                  :title="'View Order'"
                  hide-footer
                >
                  <View_items
                    @update="reload()"
                    :selected-order="selectedOrder"
                  ></View_items>
                </b-modal>
                <b-modal
                  id="bv-view-returns"
                  size="xl"
                  :title="'View Returns'"
                  hide-footer
                >
                  <View_returns
                    @update="reload()"
                    :selected-order="selectedOrder"
                  ></View_returns>
                </b-modal>
                <b-modal
                  id="show-payment"
                  size="xl"
                  :title="'Order #' + selectedOrder?.ref_id"
                >
                  <Payments :order="selectedOrder"></Payments>
                </b-modal>
                <b-modal
                  id="bv-mark-as-shipped"
                  size="xl"
                  :title="'Marks As Shipped Order'"
                  hide-footer
                >
                  <mark-as-shipped
                    @update="reload()"
                    :selected-order="selectedOrder"
                  ></mark-as-shipped>
                </b-modal>
              </div>
              <!-- Search -->
              <!--              <div class="col-sm-12 col-md-6">-->
              <!--                <div id="tickets-table_filter" class="dataTables_filter text-md-right">-->
              <!--                  <label class="d-inline-flex align-items-center mr-5">-->
              <!--                    Search:-->
              <!--                    <b-form-input v-model="filter" type="search" class="form-control form-control-sm ml-2"></b-form-input>-->
              <!--                    &lt;!&ndash; <b-form-input v-model="filter" type="search" class="form-control form-control-sm ml-2"></b-form-input> &ndash;&gt;-->
              <!--                  </label>-->
              <!--                </div>-->
              <!--              </div>-->

              <!-- End search -->
            </div>
            <div class="tab-container">
              <b-tabs
                content-class="overflow-x-auto"
                nav-wrapper-class="no-wrap-tabs"
              >
                <b-tab
                  title="Pending"
                  active
                  @click="order_type = 'pending'"
                ></b-tab>
                <b-tab
                  title="Accepted"
                  v-if="
                    $store.state.authfack.user.roles.filter(
                      (f) => f.name != 'RestaurantPartner'
                    ).length > 0
                  "
                  @click="order_type = 'accepted'"
                ></b-tab>
                <!-- <b-tab
                  title="Out Of Stock"
                  @click="order_type = 'stock_out'"
                  v-if="
                    $store.state.authfack.user.roles.filter(
                      (f) => f.name != 'RestaurantPartner'
                    ).length > 0
                  "
                ></b-tab> -->
                <b-tab title="Shipped" @click="order_type = 'shipped'"></b-tab>
                <b-tab
                  title="Delivered"
                  @click="order_type = 'delivered'"
                ></b-tab>
              </b-tabs>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                :key="orders.key"
                :items="orders.data"
                :fields="
                  fields.filter((f) =>
                    order_type == 'shipped'
                      ? f != 'delivered_at' && f != 'order_status'
                      : order_type == 'delivered'
                      ? f != 'order_status'
                      : order_type == 'pending'
                      ? f != 'delivered_at' &&
                        f != 'Payment' &&
                        f != 'shipped_at'
                      : order_type == 'accepted'
                      ? f != 'delivered_at' &&
                        f != 'Payment' &&
                        f != 'shipped_at'
                      : f
                  )
                "
                responsive="sm"
                :filter="filter"
                :current-page="currentPage"
              >
                <template v-slot:cell(payment)="row">
                  <i
                    class="fa fa-check-circle p-2"
                    aria-hidden="true"
                    style="color: green"
                    v-if="
                      row.item.payment_status &&
                      row.item.payment_status.status == 'paid'
                    "
                  >
                    Paid Online</i
                  >
                  <div style="display: flex; gap: 0px">
                    <div
                      v-if="
                        row.item.order_status != 'pending' &&
                        row.item.order_status != 'accepted'
                      "
                      @click="openPayment(row.item)"
                    >
                      <CardIcon />
                    </div>
                  </div>
                </template>
                <template v-slot:cell(ref_id)="row">
                  {{ row.item.ref_id }}
                  <b-row>
                    <b-col
                      ><b-badge
                        :variant="
                          row.item.order_type == 'dining'
                            ? 'primary'
                            : 'secondary'
                        "
                        >{{
                          capitalizeFirstLetter(row.item.order_type)
                        }}</b-badge
                      ></b-col
                    >
                    <b-col
                      ><b-badge
                        :variant="
                          row.item.order_type == 'credit' ? 'info' : 'success'
                        "
                        >{{
                          capitalizeFirstLetter(row.item.payment_mode)
                        }}</b-badge
                      ></b-col
                    >
                  </b-row>
                </template>
                <template v-slot:cell(images)="row">
                  <b-img
                    v-for="(im, i) in row.item.images"
                    :src="cdn + '/' + im.img_url"
                    :key="i"
                    size="20"
                  ></b-img>
                </template>
                <template v-slot:cell(restaurant)="row">
                  <p style="margin-bottom: 0px">
                    {{ row.item.restaurant?.name }}
                  </p>
                </template>
                <template v-slot:cell(city)="row">
                  <p style="margin-bottom: 0px">
                    {{ row.item.restaurant?.city }}
                  </p>
                </template>
                <template v-slot:cell(view_items)="row">
                  <!-- <b-button class="text-center"
                    ><i class="fa fa-list-alt"></i
                  ></b-button> -->
                  <div style="display: flex; gap: 0px">
                    <div @click="openItems(row.item)">
                      <ListIcon />
                    </div>
                  </div>
                </template>
                <template v-slot:cell(order_status)="row">
                  <div style="display: flex; gap: 0px">
                    <div
                      v-if="
                        $store.state.authfack.user.roles.filter(
                          (f) => f.name != 'RestaurantPartner'
                        ).length > 0 && row.item.order_status == 'pending'
                      "
                      @click="acceptOrder(row.item)"
                    >
                      <AcceptIcon />
                    </div>
                    <div
                      @click="markAsPending(row.item)"
                      v-if="
                        $store.state.authfack.user.roles.filter(
                          (f) => f.name != 'RestaurantPartner'
                        ).length > 0 && row.item.order_status == 'test'
                      "
                    >
                      <PendingIcon />
                    </div>
                    <div
                      v-if="
                        $store.state.authfack.user.roles.filter(
                          (f) => f.name != 'RestaurantPartner'
                        ).length > 0 && row.item.order_status == 'accepted'
                      "
                      @click="markAsShipped(row.item)"
                    >
                      <ShippedIcon />
                    </div>
                  </div>
                  <!-- <p v-else>{{ row.item.order_status }}</p> -->
                </template>
                <template v-slot:cell(actions)="row">
                  <!-- <i class="fa fa-pen"></i> -->
                  <div style="display: flex; gap: 0px">
                    <div
                      @click="setEdit(row.item)"
                      v-if="
                        (row.item.order_status == 'pending' &&
                          $store.state.authfack.user.roles.filter(
                            (f) => f.name == 'SuperAdmin'
                          ).length > 0) ||
                        (row.item.order_status == 'accepted' &&
                          $store.state.authfack.user.roles.filter(
                            (f) => f.name != 'RestaurantPartner'
                          ).length > 0)
                      "
                    >
                      <EditIcon />
                    </div>
                    <div style="display: flex; gap: 0px">
                      <div
                        v-if="
                          (row.item.order_status == 'delivered' &&
                            $store.state.authfack.user.roles.filter(
                              (f) => f.name == 'SuperAdmin'
                            ).length > 0) ||
                          (row.item.order_status == 'delivered' &&
                            $store.state.authfack.user.roles.filter(
                              (f) => f.name != 'RestaurantPartner'
                            ).length > 0)
                        "
                      >
                        <p
                          style="cursor: pointer; font-size: 18px"
                          @click="openReturns(row.item)"
                          v-b-tooltip:hover
                          title="Add Returns"
                          class="secondary"
                        >
                          📦↩️
                        </p>
                      </div>
                    </div>
                    <div
                      @click="deleteOrder(row.item)"
                      v-if="
                        $store.state.authfack.user.roles.filter(
                          (f) => f.name != 'RestaurantPartner'
                        ).length > 0 &&
                        row.item.order_status != 'shipped' &&
                        row.item.order_status != 'delivered'
                      "
                    >
                      <DeleteIcon />
                    </div>
                    <div
                      v-if="
                        $store.state.authfack.user.roles.filter(
                          (f) => f.name != 'RestaurantPartner'
                        ).length > 0 &&
                        (row.item.order_status == 'shipped' ||
                          row.item.order_status == 'stock_out')
                      "
                      @click="markAsDelivered(row.item)"
                    >
                      <DeliveredIcon />
                    </div>
                  </div>
                </template>
                <template v-slot:cell(created_at)="row">
                  {{ getFormatedDate(row.item.created_at) }}
                </template>
                <template v-slot:cell(invoice)="row">
                  <!-- <b-button
                    class="mb-2"
                    @click="downloadInvoiceFile(row.item.invoice_url)"
                    variant="success"
                    v-if="row.item.invoice_url != ''"
                    v-b-tooltip:hover
                    title="Generate"
                  >
                    <i class="fa fa-download"></i>
                  </b-button> -->
                  <div
                    style="display: flex; gap: 0px"
                    v-if="
                      $store.state.authfack.user.roles.filter(
                        (f) => f.name != 'RestaurantPartner'
                      ).length > 0 ||
                      // (row.item.order_status == 'delivered' ||
                      //   row.item.order_status == 'shipped' ||
                      //   row.item.order_status == 'stock_out')
                      ($store.state.authfack.user.roles.filter(
                        (f) => f.name == 'RestaurantPartner'
                      ).length > 0 &&
                        (row.item.order_status == 'delivered' ||
                          row.item.order_status == 'stock_out'))
                    "
                  >
                    <div
                      @click="downloadInvoiceFile(row.item.invoice_url)"
                      variant="success"
                      v-if="row.item.invoice_url !== null"
                    >
                      <DownloadIcon />
                    </div>
                    <template
                      v-if="
                        $store.state.authfack.user.roles.filter(
                          (f) => f.name != 'RestaurantPartner'
                        ).length > 0
                      "
                    >
                      <div @click="generateInvoice(row.item)">
                        <RegenerateIcon
                          :title="
                            row.item.invoice_url != null
                              ? 'Regenerate'
                              : 'Generate'
                          "
                        />
                      </div>
                    </template>
                  </div>
                  <!-- <b-button
                    v-b-tooltip:hover
                    :title="
                      row.item.invoice_url != '' ? 'Regenerate' : 'Generate'
                    "
                  >
                    <template v-if="row.item.invoice_url != ''">
                      <i class="fa fa-recycle"></i>
                    </template>
                    <template v-else>
                      <i class="fa fa-down"></i>
                    </template>
                  </b-button> -->
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul
                    class="pagination pagination-rounded"
                    style="margin-top: 0px !important"
                  >
                    <!-- pagination -->
                    <b-pagination
                      :key="orders.key"
                      v-model="currentPage"
                      :total-rows="orders.total"
                      :per-page="orders.per_page"
                      class="dataTables_paginate"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
@media (max-width: 768px) {
}
.tab-container {
  max-width: 100%;
  overflow-x: auto;
}
.no-wrap-tabs {
  white-space: nowrap;
  width: max-content;
}
.dataTables_paginate {
  display: flex !important;
}
</style>
